/**
 * Single base URL for session app-data API (brand admin backend via nginx on analyze.nyafaz.com).
 * Production: https://analyze.nyafaz.com/session/app-data/...
 * Dev: proxied by setupProxy.js to localhost:5000
 */
export const SESSION_APP_DATA_BASE = '/session/app-data';

/** Used when the URL has no `/session/:token` segment and sessionStorage has no token yet. Only injected on `skinanalyze.nyafaz.com`. */
export const SESSION_APP_FALLBACK_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjo5LCJleHAiOjE3NzA4ODEwMDl9.GJoVxK5KZ-zmkTiIMvRVWEmq9PbxbMDqv1HRriW6i3g';

/** Production skin app host — fallback token and “home without /session/:token” apply only here. */
export const SESSION_APP_FALLBACK_HOSTNAME = 'https://analyze.nyafaz.com/';

/** Local dev (CRA/Vite default) — same fallback behavior as production. Use `location.host` (includes port). */
export const SESSION_APP_FALLBACK_DEV_HOST = 'localhost:3000';

function normalizeHost(value) {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw) return '';
  try {
    if (/^https?:\/\//i.test(raw)) {
      return new URL(raw).host.toLowerCase();
    }
  } catch {
    // Fall back to raw host compare when URL parsing fails.
  }
  return raw.replace(/^\/+|\/+$/g, '').toLowerCase();
}

export function isSessionAppFallbackHost() {
  if (typeof window === 'undefined' || !window.location?.host) return false;
  const host = normalizeHost(window.location.host);
  return host === normalizeHost(SESSION_APP_FALLBACK_HOSTNAME) || host === normalizeHost(SESSION_APP_FALLBACK_DEV_HOST);
}

/** Home/landing URL: `/` when there is no token or (on fallback host only) the active token is the fallback; `/session/:token` for a real URL token. */
export function getSessionLandingPath(token) {
  const t = typeof token === 'string' ? token.trim() : '';
  if (!t) return '/';
  if (t === SESSION_APP_FALLBACK_TOKEN && isSessionAppFallbackHost()) return '/';
  return `/session/${t}`;
}
